export const partnerCodeGroupFilterJsonSchema = {
  title: "Filter",
  type: "object",
  properties: {
    status: {
      label: "Status",
      type: "array",
      items: {
        type: "string",
        options: [
          { id: "active", displayText: "Active" },
          { id: "inactive", displayText: "Inactive" },
          { id: "expired", displayText: "Expired" },
          { id: "imported", displayText: "Imported" },
        ],
      },
    },
    partnerIds: {
      label: "Partners",
      type: "array",
      items: {
        type: "string",
        options: [{ id: "1234", displayText: "Test" }],
      },
    },
    startDate: {
      type: "string",
    },
    endDate: {
      type: "string",
    },
  },
};

export const partnerCodeGroupFilterUISchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/status",
      component: "multiSelect",
      placeholder: "Status",
      selection: "multiple",
    },
    {
      type: "Control",
      scope: "#/properties/partnerIds",
      component: "multiSelect",
      placeholder: "Partners",
      selection: "multiple",
    },
    {
      type: "Control",
      scope: "#/properties/startDate",
      component: "dateTimePicker",
      label: "Start date",
    },
    {
      type: "Control",
      scope: "#/properties/endDate",
      component: "dateTimePicker",
      label: "End Date",
      rule: {
        condition: {
          schema: {
            gt: "startDate",
          },
        },
        effect: "VALIDATE",
      },
    },
  ],
};
